// Root Query fields configured with managerPaginationCache(..., separateBySelection)
// in createNewCache. useFilteredQuery auto-tags these fields with
// @connection(key: <operationName>) so two queries that hit the same field with
// the same args but different selections get their own query-named cache bucket
// instead of colliding and refetching each other.
//
// Keep this in sync with createNewCache: add a field name here whenever you
// enable `separateBySelection` for it.
export const SELECTION_SEPARATED_FIELDS = new Set(['invoices', 'myOffersCommercial']);

export default SELECTION_SEPARATED_FIELDS;
